module.exports = __webpack_public_path__ + "img/green-btn.7c9b1a14.svg";